type TVehicle = {
  id: number;
  vehicle_name: string | null;
  vehicle_no: string;
  vehicle_type: string;
  registration_certificate: string | null;
};

type TVerificationDetails = {
  rc_status: STATUS;
  license_status: STATUS;
  license_number_status: STATUS;
  profile_photo_status: STATUS;
  license_rejection_message: string | null;
  rc_rejection_message: string | null;
  profile_photo_rejection_message: string | null;
  license_number_rejection_message: string | null;
};

type Vehicle = {
  id: number;
  driverId: number;
  vehicle_no: string;
  vehicle_name: string | null;
  vehicle_type: string;
  ownership_type: string;
  fuel_type: string;
  registration_certificate: string | null;
  extra_amenities: string | null;
  created_at: string; // Date string (ISO 8601 format)
  updated_at: string; // Date string (ISO 8601 format)
};

type PaymentDetails = {
  upi_id: string;
};

export type TDriverDetails = {
  driver: {
    id: number;
    name: string;
    current_location: string | null;
    location: string;
    dob: string; // Date string (ISO 8601 format)
    driving_license_no: string;
    license_expiry: string | null; // Date string (ISO 8601 format) or null
    email: string | null;
    isEmailVerified: boolean;
    vehicleId: number;
    profile_photo: string; // URL to the profile photo
    driving_license: string; // URL to the driving license
    registration_certificate: string; // URL to the registration certificate
    preferred_language: string; // comma-separated list of languages
    gender: string;
    phone: string;
    device_token: string | null;
    created_at: string; // Date string (ISO 8601 format)
    updated_at: string; // Date string (ISO 8601 format)
    average_rating: number;
    isDeleted: boolean;
    isVerified: boolean;
    paymentDetails: PaymentDetails;
    suspensionUntil: string | null; // Date string (ISO 8601 format) or null
    suspensionReason: string | null;
    vehicles: Vehicle[];
  },
  verificationStatus: TVerificationDetails;
};

export type TDriverListData = {
  id: number;
  name: string;
  phone: string;
  email: string | null;
  current_location: string | null;
  status: string;
  isActive: boolean;
  average_rating: number;
  isVerified: boolean;
  verification_details: TVerificationDetails;
  vehicles: TVehicle[];
  created_at: string; // Date string (ISO 8601 format)
  updated_at: string; // Date string (ISO 8601 format)
  profile_photo: string; // URL to the profile photo
  preferred_language: string; // comma-separated list of languages
};

export enum DOC_TYPE {
  PROFILE_PHOTO = 'PROFILE_PHOTO',
  LICENSE = 'LICENSE',
  LICENSE_NUMBER = 'LICENSE_NUMBER',
  RC = 'RC',
}

export enum STATUS {
  VERIFIED = 'VERIFIED',
  PENDING_UPLOAD = 'PENDING_UPLOAD',
  VERIFICATION_PENDING = 'VERIFICATION_PENDING',
  UPLOADED= 'UPLOADED',
  REJECTED = 'REJECTED',
}

interface VerificationData {
  id: number;
  driverId: number;
  document_type: DOC_TYPE;
  status: STATUS;
  rejection_message: string | null;
  verified_at: string; // ISO string format of date
  created_at: string; // ISO string format of date
  updated_at: string; // ISO string format of date
}

export interface VerificationResponse {
  data: VerificationData;
  error: string | null;
  errorDetails: string;
}
